import { render } from "./PurchaseTable.vue?vue&type=template&id=bf1bca5c&scoped=true"
import script from "./PurchaseTable.vue?vue&type=script&lang=js"
export * from "./PurchaseTable.vue?vue&type=script&lang=js"

import "./PurchaseTable.vue?vue&type=style&index=0&id=bf1bca5c&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf1bca5c"]])

export default __exports__